import { supabase } from "@/lib/supabase";
import { parseFunctionsInvokeError } from "@/lib/phase1-sync-contract";

export async function invokeEdgeJson<T extends Record<string, unknown>>(
  name: string,
  body: Record<string, unknown>,
  opts?: { surface?: "shipment" | "refund" | "generic" },
): Promise<{ success: boolean; data: T | null; error?: string }> {
  const { data, error } = await supabase.functions.invoke(name, { body });
  let payload = (data ?? null) as T | null;
  if (error) {
    const ctx = (error as { context?: Response }).context;
    if (ctx && typeof ctx.json === "function") {
      try {
        payload = (await ctx.json()) as T;
      } catch {
        payload = payload ?? null;
      }
    }
    const rec = (payload ?? {}) as { error?: string; message?: string; success?: boolean };
    return {
      success: false,
      data: payload,
      error: parseFunctionsInvokeError({ errorMessage: error.message, payload: rec, surface: opts?.surface }),
    };
  }
  const rec = (payload ?? {}) as { success?: boolean; error?: string };
  if (rec.success === false) {
    return { success: false, data: payload, error: rec.error || "Request failed" };
  }
  return { success: true, data: payload };
}
